import * as THREE from 'three';
import { C } from '../game/constants';

/** Smooth-follow camera with zoom-per-phase and impulse shake. */
export class CameraRig {
  readonly camera: THREE.PerspectiveCamera;
  private targetZ = C.camera.z;
  private shake = 0;
  private readonly focus = new THREE.Vector3();

  constructor(aspect: number) {
    this.camera = new THREE.PerspectiveCamera(55, aspect, 0.1, 400);
    this.camera.position.set(0, 6, C.camera.z);
  }

  setZoom(z: number): void { this.targetZ = z; }
  impulse(strength: number): void { this.shake = Math.min(1.2, this.shake + strength); }

  update(dt: number, target: THREE.Vector3, lookAheadY = 0): void {
    this.focus.lerp(
      new THREE.Vector3(target.x, target.y + lookAheadY, 0),
      Math.min(1, dt * C.camera.followLerp),
    );
    this.shake = Math.max(0, this.shake - dt * C.camera.shakeDecay);
    const sx = (Math.random() - 0.5) * this.shake * 0.8;
    const sy = (Math.random() - 0.5) * this.shake * 0.8;

    const z = THREE.MathUtils.lerp(this.camera.position.z, this.targetZ, dt * 3);
    // 2.5D: camera rides slightly above the focus and looks gently down,
    // so block top faces + model depth read as 3D (NSMB-style side view).
    const lift = z * 0.14;
    this.camera.position.set(this.focus.x + sx, this.focus.y + lift + sy, z);
    this.camera.lookAt(this.focus.x + sx, this.focus.y + sy, 0);
  }

  snapTo(target: THREE.Vector3): void {
    this.focus.set(target.x, target.y, 0);
    this.camera.position.set(target.x, target.y, this.targetZ);
  }
}
